import type { ComponentProps } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import useRootStore from '@/stores/useRootStore';
import Pressable, { style as containerStyle } from '../../Unistyles/Pressable';

export default function DrawerEntityListOrganizationItem({
  id,
  title,
  onPress,
}: {
  id: string;
  title: string;
  onPress?: ComponentProps<typeof Pressable>['onPress'];
}) {
  const isSelected = useRootStore(
    (state) =>
      state.organizationId === id &&
      state.activeContextPathname === '/organization' &&
      state.activeTab === 'organization',
  );

  return (
    <Pressable
      accessibilityLabel={title}
      testID="DrawerOrganizationItem"
      styleOverride={({ pressed }) => [
        containerStyle.container(undefined),
        style.item(isSelected),
        pressed && containerStyle.active,
      ]}
      onPress={(event) => {
        onPress?.(event);
      }}
    >
      <Text style={style.itemTitle(isSelected)} size="md">
        {title}
      </Text>
    </Pressable>
  );
}

const style = StyleSheet.create((theme) => ({
  item: (isSelected: boolean) => ({
    borderRadius: theme.borderRadius.xl,
    padding: theme.space('md'),
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.space('md'),
    backgroundColor: isSelected ? theme.colors.surfaceSecondary : 'transparent',
  }),
  itemTitle: (isSelected: boolean) => ({
    color: isSelected
      ? theme.colors.typography
      : theme.colors.typographySecondary,
  }),
}));
